import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";

export const calendarApi = createApi({
  reducerPath: "calendarApi",
  baseQuery: fakeBaseQuery(),
  tagTypes: ["Events", "Categories", "Groups", "SyncToken", "CalendarPublicShareSettings"],
  endpoints: () => ({}),
});
